import PropTypes from 'prop-types'
import React from 'react'
import {format} from 'ag-common/facades'
import i18n from 'i18next'
import FeedbackDownloadButton from '#components/m/Feedback/FeedbackDownloadButton'
import FeedbackUserDisplayField from '#components/m/Feedback/FeedbackUserDisplayField'
import FeedbackTitleWithIcon from '#components/m/Feedback/FeedbackTitleWithIcon'

export function FeedbackRowAsAusbilder({feedback, downloadFile}) {
  const {author, uploadDate, concerningAzubi, feedbackType} = feedback
  const formattedUploadDate = format(new Date(uploadDate), 'dd. MMMM yyyy')
  const formattedFeedbackType = i18n.t(`feedback_type_${feedbackType}`)

  return (
    <tr data-testid="feedback-row">
      <td>
        <div>
          <FeedbackTitleWithIcon feedback={feedback} />
        </div>
      </td>
      <td>
        <div>
          <FeedbackUserDisplayField user={author} />
        </div>
      </td>
      <td>
        <div>
          <span>{formattedUploadDate}</span>
        </div>
      </td>
      <td>
        <div>
          <span>{formattedFeedbackType}</span>
        </div>
      </td>
      <td>
        <div>
          <FeedbackUserDisplayField user={concerningAzubi} />
        </div>
      </td>
      <td>
        <FeedbackDownloadButton downloadFile={downloadFile} feedback={feedback} />
      </td>
    </tr>
  )
}

FeedbackRowAsAusbilder.propTypes = {
  feedback: PropTypes.shape({
    id: PropTypes.string,
    author: PropTypes.shape({
      firstname: PropTypes.string,
      lastname: PropTypes.string,
      id: PropTypes.number,
      hasErrors: PropTypes.bool,
    }),
    concerningAzubi: PropTypes.shape({
      firstname: PropTypes.string,
      lastname: PropTypes.string,
      id: PropTypes.number,
      hasErrors: PropTypes.bool,
    }),
    originalFilename: PropTypes.string,
    uploadDate: PropTypes.any,
    feedbackType: PropTypes.string,
  }),
  downloadFile: PropTypes.func.isRequired,
}
